import React from 'react';
import cc from 'classcat';

interface FlagProps {
  bgColor?: string;
  className?: string;
  styles?: any;
}

const Flag: React.FC<FlagProps> = ({
  bgColor,
  children,
  className,
  styles
}) => {
  const classes = cc([
    'pt-1',
    'px-2',
    'pb-2',
    'mr-1',
    bgColor ? `bg-${bgColor}` : 'bg-blue',
    className
  ]);
  return (
    <span className={classes} style={styles}>
      {children}
    </span>
  );
};

export default Flag;
